import { UiDiv, UiText } from '@webfox-sc/core';
import { IS_DEACTIVATED } from '../../app.config';

import React, { Suspense } from 'react';

const LandingProvider = React.lazy(() => import('./LandingProvider'));
const LandingView = React.lazy(() => import('./LandingView'));

interface LandingProps {
  defaultViewType: 'offer' | 'certificate';
}

const Landing: React.FC<LandingProps> = ({ defaultViewType }) => {
  if (IS_DEACTIVATED) {
    return (
      <UiDiv gridColumn="1 / 4" background="red" textAlign="center" marginTop="s" padding="s">
        <UiText>
          Diese Version der SMG-App wurde deatktiviert. Bitte kontaktieren Sie Ihren Servicemanager.
          </UiText>
        </UiDiv>
    );
  }
  return (
    <Suspense fallback={<></>}>
      <LandingProvider>
        <LandingView defaultViewType={defaultViewType} />
      </LandingProvider>
    </Suspense>
  );
};

export default Landing;
